import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookie from 'js-cookie';

// COMPONENTES
import MyAutoCompleteSublabel from '../../../../components/inputs/MyAutoCompleteSublabel';
import MyTextArea from '../../../../components/inputs/MyTextArea';

const ModalDetalles = ({ open, onClose, refresh, data, incidencias }) => {

    const [ formValues, setFormValues ] = useState({
    
        reason_id: null,
        solution: null,
        is_authorized: 0

    });

    useEffect(() => {

        if(Object.keys(data).length > 0){

            setFormValues({
                ...data,
                is_authorized: data.is_authorized ?? 0
            });

        }

    }, [data]);

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Detalles
            </DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Formik
                    initialValues={formValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        reason_id: Yup.string().required('Selecciona una Opcion'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try {

                            const filterValue = incidencias.filter(obj => obj.value === values.reason_id)[0];

                            const formData = {

                                reason_id: filterValue.value,
                                severity: filterValue.sublabel,
                                solution: values.solution,
                                is_authorized: Number(values.is_authorized),
                                id: data.id,
                                location: data.location,
                                vehicle: data.vehicle,
                                event_date: data.event_date,

                            }

                            const response = await myApi.put('/events/update', formData);

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Registro actualizado',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit, values, setFieldValue }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* MOTIVO DE RETRASO */}

                            <Grid size={12}>

                                <MyAutoCompleteSublabel
                                    name="reason_id"
                                    label="Motivo de Retraso"
                                    options={incidencias}
                                />

                            </Grid>

                            {/* SOLUCION */}

                            <Grid size={12}>

                                <MyTextArea
                                    name="solution"
                                    label="Describa la solucion empleada para esta parada"
                                />

                            </Grid>

                            {/* AUTORIZADO */}

                            <Grid size={12}>

                                <RadioGroup
                                    row
                                    name="is_authorized"
                                    value={String(values.is_authorized ?? 0)}
                                    onChange={(event) => setFieldValue('is_authorized', Number(event.target.value))}
                                >
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio color="primary" />}
                                        label="Autorizado"
                                    />
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio color="primary" />}
                                        label="No Autorizado"
                                    />
                                </RadioGroup>

                            </Grid>

                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default ModalDetalles
